/* unplugin-vue-components disabled */import { render } from "./AsideNavbar.vue?vue&type=template&id=01bc7304&scoped=true"
import script from "./AsideNavbar.vue?vue&type=script&lang=js"
export * from "./AsideNavbar.vue?vue&type=script&lang=js"

import "./AsideNavbar.vue?vue&type=style&index=0&id=01bc7304&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bc7304"]])

export default __exports__